import React, { lazy, Suspense } from "react";
import componentLoader from "../../utilities/componentLoader";

const ProtocolDetail = lazy(() =>
  componentLoader(() => import("./components/ProtocolDetail")),
);

export default () => (
  <div>
    <Suspense fallback={<div />}>
      <section>
        <ProtocolDetail />
      </section>
    </Suspense>
  </div>
);
